import { createStore } from "zustand-x"
import type { TournamentListItem } from "@/domain/tournament/model/Tournament"

interface TournamentListStoreState {
  tournaments: TournamentListItem[]
  isLoaded: boolean
  errorMessage: string
}

function makeInitTournamentListState(): TournamentListStoreState {
  return { tournaments: [], isLoaded: false, errorMessage: "" }
}

const TournamentListStore = createStore<TournamentListStoreState>(
  makeInitTournamentListState(),
  { name: "TournamentListStore" },
)

export { TournamentListStore, makeInitTournamentListState }
export type { TournamentListStoreState }
